import { css, html, LitElement } from 'lit'
import { property, customElement } from 'lit/decorators.js'

@customElement('zaptic-timeline-user')
export class TimelineUser extends LitElement {
    static styles = css`
        .link {
            color: var(--blue-600);
            cursor: pointer;
        }

        .plain {
            color: var(--grey1);
        }

        .name {
            font-weight: var(--font-weight-bold);
        }
    `

    @property()
    name: string

    @property()
    type: 'link' | 'plain' = 'plain'

    render() {
        return html`<span class="${this.type} name"><b>${this.name}</b></span>`
    }
}
